export {
    default as PhotoUploader
}
from './photo'

export {
    default as Uploader
}
    from './uploader'